import utility from './utility'

const depositFunds = {
    init: function () {
        [...document.querySelectorAll("#account--add-funds")].map(depositForm => {
            new this.depositActions(depositForm);
        });
        this.resultExpandClick();
    },

    depositActions: class {
        constructor(depositForm) {
            [...depositForm.querySelectorAll('.choose-plays input[type="radio"]')].map(option => {
                option.onclick = () => {
                    this.detectValue(option);
                }
            });

            this.depositForm = depositForm;
            this.otherLabel = depositForm.querySelector('.choose-plays .input-other');
            this.otherInput = depositForm.querySelector('.choose-plays .input-other input');
            this.submitButtons = [...document.querySelectorAll('#account--add-funds #account-payment-methods button[type="submit"]')];
            this.paymentAmount = depositForm.querySelector("input[name=PaymentAmount]");
            this.paymentMethods = [...document.querySelectorAll("#account-payment-methods .payment-methods")];
            this.activePaymentMethod = "";
            this.checkBraintreeHostedFields = false;
            this.checkBraintreeHostedFormValid = false;
            this.checkCvvOnlyHostedFields = false;


            if (depositForm.querySelector("input[name=SavePayPal]")) {
                this.savePayPal = depositForm.querySelector("input[name=SavePayPal]").checked;
            } else {
                this.savePayPal = true
            }

            this.paymentMethods.map(paymentMethod => {
                paymentMethod.onclick = (el) => {
                    if (!el.currentTarget.classList.contains('active')) {
                        this.paymentMethods.map(pm => utility.removeClass(pm, "active")) && utility.addClass(el.currentTarget, "active");
                        this.handlePaymentMethodChange(el.currentTarget);
                        this.activePaymentMethod = el.currentTarget;
                    }
                }
            });

            const createPayID = depositForm.querySelector(".payid-register");
            if (createPayID) {
                createPayID.onclick = (el) => this.createPayIdAccount(el.currentTarget);
            }

            const createBPayAccount = depositForm.querySelector(".bpay-register");
            if (createBPayAccount) {
                createBPayAccount.onclick = (el) => this.createBPayAccount(el.currentTarget);
            }

            depositForm.onkeypress = (e) => {
                var key = e.charCode || e.keyCode || 0;
                if (key === 13) {
                    e.preventDefault();
                }
            };
            depositForm.onsubmit = () => {
                this.beginDeposit();
                return false;
            };

            this.detectValue(document.querySelector("input[name=add_funds]:checked"));

            // Recreate PayPal button is 'Save Paypal' button is changed
            const payPalSaveCheck = depositForm.querySelector("input[name=SavePayPal]");
            if (payPalSaveCheck) {
                payPalSaveCheck.onchange = (el) => {
                    this.savePayPal = el.currentTarget.checked;
                    el.currentTarget.setAttribute("disabled", "disabled");
                    utility.addClass(document.getElementById("checkSavePayPal"), "disabled");
                    this.handlePayPal('paypal');
                }
            }

            this.paymentTransactionRef = "";
            window.addEventListener("message", this.handleHostedPaymentMessage.bind(this));
        }

        handlePaymentMethodChange(paymentOption) {
            utility.removeFormInputErrors(this.depositForm);
            if (paymentOption.dataset.paymentmethod === "1001" && !paymentOption.classList.contains('saved')) {
                // New credit card and NOT a 'saved' method
                //check if braintree instance already exists. Inititated Once
                if (!this.checkBraintreeHostedFields) {
                    this.handlePayPal('hosted')
                }
            }
            else if (paymentOption.dataset.paymentmethod === "4001" && !paymentOption.classList.contains('saved')) {
                //dont re create paypal buttons if saved paypal method is clicked
                this.handlePayPal('paypal')
            }
            else if (paymentOption.dataset.paymentmethod === "5001") {
                this.bindCopyButtons();
                this.bindSendBPayEmail();
            }
            else if (paymentOption.dataset.paymentmethod === "11001") {
                this.bindCopyButtons();
                this.bindSendPayIdEmail();
            }
            else if (paymentOption.dataset.paymentmethod === "12001") {
                // pay in-store doesn't allow cents, reset to zero if not a whole amount
                if (Number(this.otherInput.value) % 1 != 0) {
                    this.otherInput.value = 0;
                    this.changeValues('0.00');
                }
                this.otherInput.onkeydown = (evt) => {
                    var charCode = (evt.which) ? evt.which : evt.keyCode;
                    return !(charCode == 110 || charCode == 190);
                }
            }
            else {
                this.otherInput.onkeydown = null;
            }
        }

        beginDeposit() {
            const paymentOption = this.activePaymentMethod;
            const paymentAmount = this.paymentAmount.value;
            this.depositForm.querySelector("input[name=PaymentMethodId]").value = paymentOption.dataset.paymentmethod;
            this.depositForm.querySelector("input[name=CustomerPaymentMethodId]").value = paymentOption.dataset.customerpaymentid;
            this.disableSubmitButtons();
            this.customerPaymentMethodId = paymentOption.dataset.customerpaymentid;

            if (paymentOption.dataset.paymentmethod === "4001") {
                // check if payment method is PayPal -> Validate Deposit
                this.validateDeposit(paymentOption.dataset.methodname, paymentAmount);
            }
            else if ((paymentOption.dataset.paymentmethod === "1001" || paymentOption.dataset.paymentmethod === "1002") && paymentOption.classList.contains('saved')) {
                // Validate saved Credit Cards
                this.validateDeposit(paymentOption.dataset.methodname, paymentAmount);
            }

            //else if (paymentOption.classList.contains('saved')) {
            else {
                // for everything else not PayPal
                if (paymentOption.dataset.paymentmethod != "1001") {
                    this.performDeposit();                 
                }
            }
        }

        disableSubmitButtons() {
            utility.disableButton(document.getElementById("global--deposit-confirmation-popup-button"));
            this.submitButtons.map(b => utility.disableButton(b));
        }

        enableSubmitButtons() {
            utility.enableButton(document.getElementById("global--deposit-confirmation-popup-button"));
            this.submitButtons.map(b => utility.enableButton(b));
        }

        disablePaymentMethods() {
            this.paymentMethods.map(b => utility.addClass(b, "disabled"));
            utility.showNotificationPopup({
                title: "Processing PayPal",
                centreContent: true,
                hideCloseIcon: true,
                content: `Please wait...`
            });
        }

        enablePaymentMethods() {
            this.paymentMethods.map(b => utility.removeClass(b, "disabled"));
        }
       
        validateDeposit(paymentMethod, paymentAmount, deviceData, nonce) {
            let formData = utility.getFormData(this.depositForm);
            let hostingRequired = this.activePaymentMethod.dataset.hostingrequired ? this.activePaymentMethod.dataset.hostingrequired : 0;

            //Used for create new hosted field credit card
            if (deviceData) {
                formData += `&BTRDeviceData=${deviceData}`
            }
            if (nonce) {
                formData += `&BTRPaymentNonce=${encodeURIComponent(nonce)}`
            }

            const ajaxSuccess = (e) => {
                utility.removeFormInputErrors(this.depositForm);
                var result = JSON.parse(e.target.responseText);
                if (result.result === "S") {
                    document.getElementById("global--deposit-confirmation-popup-method").innerHTML = paymentMethod;
                    document.getElementById("global--deposit-confirmation-popup-amount").innerHTML = Number(paymentAmount).toFixed(2);
                    document.getElementById("global--deposit-confirmation-popup-button").onclick = (ev) => {
                        if (paymentMethod == 'PayPal') {
                            // Handle PayPal Tokenized Payment
                            // disable both popup buttons once Ok is clicked
                            document.getElementById("global--deposit-cancel-popup-button").disabled = true;            
                            utility.disableButton(document.getElementById("global--deposit-confirmation-popup-button"));

                            this.handlePayPal('paypal-deposit')
                        }
                        else if (paymentMethod == 'Credit Card') {                         
                            //new credit card
                            this.performPayPalDeposit(deviceData, nonce)
                        }
                        else if ((paymentMethod == 'Visa' || paymentMethod == 'Mastercard') && hostingRequired ==1) {
                            //saved credit card
                            this.handlePayPal('hosted-deposit')
                        }
                        else {
                            this.performDeposit(ev.currentTarget);
                        }

                    };
                    document.getElementById("global--deposit-cancel-popup-button").onclick = (ev) => {
                        utility.hidePopups();
                    };
                    utility.showPopup(document.getElementById("global--deposit-confirmation-popup"));
                }
                else if (result.result === "E") {
                    utility.showNotificationPopup({
                        title: "Error",
                        content: result.message
                    });
                }
                else if (result.result === "F") {
                    result.fieldErrors.map(error => {
                        utility.addFormInputError(this.depositForm, error.Name, error.Error);
                    });
                }
                else {
                    utility.showNotificationPopup({
                        title: "Error",
                        content: "An unknown error has occurred"
                    });
                }
            };
            const ajaxError = () => {
                utility.removeFormInputErrors(this.depositForm);
            };
            const ajaxAlways = () => {
                this.enableSubmitButtons();
                utility.removeClass(this.activePaymentMethod, "disabled");
                this.enablePaymentMethods();
            };
            const ajaxOptions = {
                url: "/api/web/account/validate-deposit",
                method: "POST",
                data: formData,
                success: ajaxSuccess,
                error: ajaxError,
                always: ajaxAlways
            };

            utility.ajaxRequest(ajaxOptions);
        }

        performDeposit(depositButton) {
            const ajaxSuccess = (e) => {
                utility.removeFormInputErrors(this.depositForm);
                this.handleDepositCompleteResponse(JSON.parse(e.target.responseText));
            };
            const ajaxError = () => {
                this.enableSubmitButtons();
                utility.removeFormInputErrors(this.depositForm);

                //clear paypal disable
                this.enablePaymentMethods();

            };
            const ajaxOptions = {
                url: "/api/web/account/perform-deposit",
                method: "POST",
                data: utility.getFormData(this.depositForm),
                success: ajaxSuccess,
                error: ajaxError
            };
            this.disableSubmitButtons();
            utility.ajaxRequest(ajaxOptions);
        }
       
        handleHostedPaymentMessage(event) {
            if (!event || !event.data) {
                return;
            }
            if (event.type !== "message") {
                return;
            }
            if (event.data.eventAction !== "DEP") {
                return;
            }
            if (event.origin !== window.location.origin) {
                return;
            }
            if (!event.data.paymentRef || !this.paymentTransactionRef || event.data.paymentRef !== this.paymentTransactionRef) {
                return;
            }
            if (event.data.paymentMethodId === 7001) {
                this.completePaysafecardDeposit(event);
            }
        }

        beginPaysafecardDeposit(authURL) {
            const ajaxOptions = {
                url: "/api/web/account/deposit-hosted-payment",
                method: "POST",
                data: "paymentUrl=" + encodeURIComponent(authURL) + "&paymentMethodId=7001",
                success: (e) => utility.showHostedPaymentPopup(e.target.responseText),
                error: () => this.enableSubmitButtons()
            };
            utility.ajaxRequest(ajaxOptions);
        }

        completePaysafecardDeposit(event) {
            utility.setHostedPaymentPopupComplete();
            const ajaxSuccess = (e) => {
                this.handleDepositCompleteResponse(JSON.parse(e.target.responseText));
            };
            const ajaxError = () => {
                if (event.data.eventType === "cancel") {
                    utility.hidePopups();
                }
                else {
                    utility.showNotificationPopup({ title: "Error", content: "We are waiting for a response from paysafecard. The transaction may or may not go through. It might take up to 15 minutes to get a result from them. We will email you as soon as we can." });
                }
            };
            const ajaxOptions = {
                url: "/api/web/account/deposit-psc-complete",
                method: "POST",
                data: `paymentReferenceNo=${event.data.paymentRef}`,
                success: ajaxSuccess,
                error: ajaxError,
                always: () => this.enableSubmitButtons()
            };
            utility.ajaxRequest(ajaxOptions);
        }

        createPayIdAccount(btn) {
            utility.disableButton(btn);
            const ajaxOptions = {
                url: "/api/web/account/create-payid-account",
                method: "POST",
                success: (e) => {
                    const result = JSON.parse(e.target.responseText);
                    utility.showNotificationPopup({
                        title: result.success ? "Pending" : "Error",
                        content: result.message,
                        hideCloseIcon: true,
                        button: {
                            text: "OK",
                            url: "/account/deposit/"
                        }
                    });
                  result.success && this.checkPayIdStatus(result.id);
                },
                always: () => utility.enableButton(btn)
            };
            utility.ajaxRequest(ajaxOptions);
        }

        createBPayAccount(btn) {
            utility.disableButton(btn);
            const ajaxOptions = {
                url: "/api/web/account/create-bpay-account",
                method: "POST",
                success: (e) => {
                    const result = JSON.parse(e.target.responseText);
                    if (result.customerPaymentMethodId === 0) {
                        utility.showNotificationPopup({
                            title: "Error",
                            content: "An error occurred while creating your BPAY reference number. Please try again later."
                        })
                    }
                    else {
                        this.setBPayAccountDetails(result);
                        this.bindSendBPayEmail();
                    }
                },
                always: () => utility.enableButton(btn)
            };
            utility.ajaxRequest(ajaxOptions);
        }

        setBPayAccountDetails(data) {
            utility.addClass(this.activePaymentMethod, "BPay")
            const bPayContent =
                `
                    <div class="payid-layout bpay-details">
                        <p>
                            <span>Biller Code:</span>
                            <span>${data.billerCode}<span class="copy copy-payid" data-text="${data.billerCode}">Copy</span></span>
                        </p>
                        <p>
                            <span>Ref:</span>
                            <span>${data.reference}<span class="copy" data-text="${data.reference}">Copy</span></span>
                        </p>
                    </div>

                    <p class="instructions">
                        Your funds will be added into your account as credit once we receive it.
                    </p>
                    <p class="instructions">
                        Telephone and Internet Banking - BPAY Contact your bank or financial institution to make this payment, from your cheque, savings, debit, credit card or transaction account. More info: www.bpay.com.au
                    </p>
                    <p class="instructions email-payment-details-sent" id="email-payment-details-sent-bpay"></p>
                    <a class="email-payment-details" id="email-bpay">
                        Email me the details
                    </a>
                `
            document.querySelector(".BPay .payment-content").innerHTML = bPayContent;
            document.querySelector(".BPay .payment-expand").click();
            this.bindCopyButtons();
        }

        checkPayIdStatus(id) {
            var _this = this;
            var interval = setTimeout(pollStatus, 5000);
            function pollStatus() {
                const ajaxOptions = {
                    url: `/api/web/account/check-payid-account-status?id=${id}`,
                    method: "POST",
                    success: (e) => {
                        const result = JSON.parse(e.target.responseText);
                        if (result.statusId === "A") {
                            clearInterval(interval);
                            _this.showPayIdPopup(id);
                        } else if (result.statusId === "P") {
                            interval = setTimeout(pollStatus, 5000);
                        }
                        else {
                            clearInterval(interval);
                            utility.showNotificationPopup(
                                {
                                    title: "Error", content: result.message, hideCloseIcon: true,
                                    button: {
                                        text: "OK",
                                        url: "/account/deposit/"
                                    }
                                }
                            );
                        }
                    },
                };
                utility.ajaxRequest(ajaxOptions);
            }
        }

        showPayIdPopup(paymentMethodId) {
            const ajaxOptions = {
                url: "/api/web/account/get-payid-account-details?customerPaymentMethodId=" + paymentMethodId,
                method: "GET",
                success: (e) => {
                    utility.showContentPopup(e.target.responseText, "/account/deposit/");
                    this.bindCopyButtons();
                    this.bindSendPayIdEmail();
                },
                always: () => this.enableSubmitButtons()
            };
            utility.ajaxRequest(ajaxOptions);
        }

        bindSendPayIdEmail() {
            const button = document.getElementById("email-payid");
            if (button) {
                button.onclick = (el) => this.sendPayIdEmail(el.currentTarget);
            }
        }

        sendPayIdEmail(button) {
            const emailMsg = document.getElementById("email-payment-details-sent-payid");
            const ajaxOptions = {
                url: "/api/web/account/email-payid-account-details",
                method: "POST",
                success: (e) => {
                    button.style.display = "none";
                    utility.addClass(emailMsg, "active");
                    emailMsg.innerText = "Your PayID details have been emailed.";
                }
            };
            utility.ajaxRequest(ajaxOptions);
        }

        bindSendBPayEmail() {
            const button = document.getElementById("email-bpay");
            if (button) {
                button.onclick = (el) => this.sendBPayEmail(el.currentTarget);
            }
        }

        sendBPayEmail(button) {
            const emailMsg = document.getElementById("email-payment-details-sent-bpay");
            const ajaxOptions = {
                url: "/api/web/account/email-bpay-account-details",
                method: "POST",
                success: (e) => {
                    button.style.display = "none";
                    utility.addClass(emailMsg, "active");
                    emailMsg.innerText = "Your BPAY details have been emailed.";
                }
            };
            utility.ajaxRequest(ajaxOptions);
        }

        showBlueshyftPaymentCode(url, paymentCode) {
            const content = `
            <p class="blueshyft-amount">$${this.paymentAmount.value}</p>
            <p class="blueshyft-text">Present this QR code to a Pay In-store outlet for an instant deposit to your account.</p>
            <img src="${url}"/>
            <p class="blueshyft-code">${paymentCode}</p>
            <p class="blueshyft-text">We've also emailed you a copy.</p>`;

            utility.showNotificationPopup({
                title: "Deposit Code",
                content: content,
                hideIcon: true,
                hideCloseIcon: false,
            });

            this.checkBlueshyftIdStatus(paymentCode);
            this.enableSubmitButtons();
        }

        checkBlueshyftIdStatus(paymentCode) {
            var interval = setTimeout(pollStatus, 5000);
            const content = `
            <p class="blueshyft-text">You will receive a digital receipt</p>
            <p class="blueshyft-text">Click "Done" below to see your updated balance.</p>
             <span class="check" id="success-gif">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><path class="checkmark" fill="none" d="M15 28l8 7 12-18" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            </span>`;

            function pollStatus() {
                const ajaxOptions = {
                    url: `/api/web/account/check-blueshyft-status?code=${paymentCode}`,
                    method: "POST",
                    success: (e) => {
                        const result = JSON.parse(e.target.responseText);
                        if (result.statusId === "C") {
                            clearInterval(interval);
                            utility.showNotificationPopup({
                                title: "All Done",
                                content: content,
                                hideIcon: true,
                                hideCloseIcon: true,
                                button: {
                                    text: "Done",
                                    url: "/"
                                }
                            });
                            utility.addClass(document.getElementById("success-gif"), 'active');
                        }
                        else if (result.statusId === "P") {
                            interval = setTimeout(pollStatus, 5000);
                        }
                        else {
                            clearInterval(interval);
                            utility.showNotificationPopup(
                                {
                                    title: "Error", content: result.message, hideCloseIcon: true,
                                    button: {
                                        text: "OK",
                                        url: "/"
                                    }
                                }
                            );
                        }
                    },
                };
                utility.ajaxRequest(ajaxOptions);
            }
        }

        bindCopyButtons() {
            const copyButtons = document.querySelectorAll(".bpay-details .copy");
            for (let i = 0; i < copyButtons.length; i++) {
                copyButtons[i].onclick = function (ev) {
                    const button = ev.currentTarget;
                    const buttonData = button.dataset.text;
                    const copySuccess = function () {
                        button.innerText = "Copied";
                        utility.addClass(button, "copied");
                    };
                    const copyError = () => {

                    };
                    utility.copyTextToClipboard(buttonData, copySuccess, copyError);
                };
            }
        }

        handleDepositCompleteResponse(result) {
            if (result.result === "S") {
                const successUrl = this.depositForm["SuccessUrl"] ? this.depositForm["SuccessUrl"].value : "";
                // show deposit success popup
                utility.ajaxRequest({
                    url: "/api/web/account/deposit-success",
                    method: "POST",
                    data: "successUrl=" + successUrl + "&referenceNo=" + result.paymentRef,
                    success: function (e) {
                        utility.showContentPopup(e.target.responseText);
                    }
                });
                // first deposit event
                utility.ajaxRequest({
                    url: "/api/web/account/get-deposit-details",
                    method: "POST",
                    data: "referenceNo=" + result.paymentRef,
                    success: function (e) {
                        const result = JSON.parse(e.target.responseText);
                        if (result.FirstDeposit) {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                "event": "first_deposit"
                            });

                            //uetq - Bing Universal Event Tracking 
                            window.uetq = window.uetq || [];
                            window.uetq.push('event', 'first_deposit', {});

                            //ADGILE BVOD first deposit (temporary)
                            window.adgile = window.adgile || [];
                            window.adgile.push(['viewid', 'AG-01-dq98zc5n']);
                            window.adgile.pixel();
                        }
                    }
                });
            }
            else if (result.result === "PP" && result.paymentMethodId === 7001) {
                this.paymentTransactionRef = result.paymentRef;
                this.beginPaysafecardDeposit(result.paysafecardAuthURL);
            }
            else if (result.result === "PP" && result.paymentMethodId === 11001) {
                this.showPayIdPopup(result.customerPaymentMethodId);
            }
            else if (result.result === "PP" && result.paymentMethodId === 12001) {
                this.showBlueshyftPaymentCode(result.blueshyftPaymentCodeURL, result.blueshyftPaymentCode);
            }
            else if (result.result === "PU") {
                this.enableSubmitButtons();
                utility.showNotificationPopup({
                    title: "Pending",
                    content: result.message
                });
            }
            else if (result.result === "C") {
                this.enableSubmitButtons();
                utility.showNotificationPopup({
                    title: "Cancelled",
                    content: result.message
                });
            }
            else if (result.result === "R") {
                window.location.href = result.location;
            }
            else if (result.result === "E") {
                this.enableSubmitButtons();
                utility.enableButton(this.depositButton);
                utility.showNotificationPopup({
                    title: "Error",
                    content: result.message
                });
            }
            else if (result.result === "F") {
                this.enableSubmitButtons();
                result.fieldErrors.map(error => {
                    utility.addFormInputError(this.depositForm, error.Name, error.Error);
                });
            }
            else {
                this.enableSubmitButtons();
                utility.showNotificationPopup({
                    title: "Error",
                    content: "An unknown error has occurred"
                });
            }

            //clear disabled forms
            if (result.result !== "R" || result.result !== "S") {
                this.enablePaymentMethods();
            }
        }

        detectValue(option) {
            if (option.value == 'other') {
                this.otherValues();
                return;
            }
            this.otherLabel.classList.remove('active');
            this.changeValues(option.value);
        }

        otherValues() {
            let otherValue = this.otherInput.value;
            if (!otherValue) {
                this.otherInput.value = 0.00;
                this.changeValues('0.00');
            }
            else {
                this.changeValues(otherValue);
            }
            this.otherLabel.classList.add('active');
            this.otherInput.oninput = () => {
                let otherValue = Number(this.otherInput.value).toFixed(2);
                if (this.otherInput.value == '') {
                    otherValue = '0.00';
                }
                this.changeValues(otherValue);
            };
        }

        changeValues(value) {
            this.paymentAmount.value = value;
            this.submitButtons.map(submitButton => {
                submitButton.textContent = `Add $${value}`;
            });

           /** Recreate the papal button if:
            * Add Funds Amount Value changes
            * and the 'Add PayPal' accordion is open 
            * and the its not the saved PayPal accordion **/
            if (this.activePaymentMethod && this.activePaymentMethod.dataset.paymentmethod === "4001" && !this.activePaymentMethod.classList.contains('saved')) {
                this.handlePayPal('paypal');
            }
        }


        /**  ------------------- ------------------------------- ---------------------------*/

        /** PayPal Hosted Fields Credit Card*/

        createHostedFields(deviceData, clientInstance) {
            let that = this;
            that.enableSubmitButtons();
            let form = document.getElementById('account--add-funds');
            let submit = document.getElementById('submit-1001');
            let loader = document.getElementById('bt-loader');
            let formloader = document.getElementById('bt-form');  
            submit.setAttribute("disabled", "disabled");

            braintree.hostedFields.create({
                preventAutofill: false,
                client: clientInstance,
                styles: {
                    input: {
                        'input': 'hosted-fields',
                        'font-size': '1rem',
                        color: '#2C68A5'
                    },
                    'input.invalid': {
                        'color': 'red'
                    },
                },
                fields: {
                    number: {
                        supportedCardBrands: {
                            visa: true,  
                            'master-card': true 
                        },
                        container: '#card-number',
                        placeholder: 'Enter your card number'
                    },
                    cardholderName: {
                        selector: '#card-name',
                        placeholder: 'Name as it appears on your card'
                    },
                    cvv: {
                        container: '#cvv',
                        placeholder: 'Enter valid 3-digit CVV'
                    },
                    expirationDate: {
                        container: '#expiration-date',
                        placeholder: 'MM/YYYY'
                    }
                }
            }, function (hostedFieldsErr, hostedFieldsInstance) {      
                if (hostedFieldsErr) {
                    let error = `There was an error when trying to add a new card.<br/>Please try again.`;
                    utility.logError("HF New Card Deposit: Error creating client", hostedFieldsErr, function () {
                        that.handlePayPalError(error); 
                    });
                    return;
                }

                //hide loader, show form
                if (loader) {
                    loader.style.display = 'none';
                }
                if (formloader) {
                    utility.removeClass(formloader, "disabled");
                }

                // Set auto focus on card number
                hostedFieldsInstance.focus('number', function (focusErr) {
                    if (focusErr) {
                        //console.error(focusErr);
                    }
                });

                hostedFieldsInstance.on('blur', function (event) {
                    var field = event.fields[event.emittedBy];
                    var container = field.container;
                    var label = container.nextElementSibling;

                    if (field.isEmpty) {
                        utility.addClass(label, "show");
                        utility.addClass(container, "is-invalid");
                    }
                    //else if (field.isPotentiallyValid) {
                    //    utility.addClass(label, "show");
                    //    utility.addClass(container, "is-invalid");

                    //}
                    else {
                        utility.removeClass(label, "show");
                        utility.removeClass(container, "is-invalid");

                    }
                });

                // check validity and enable submit
                hostedFieldsInstance.on('validityChange', function (event) {
                    var allValid = true;
                    var key;

                    for (key in event.fields) {
                        utility.removeClass(event.fields[key].container, "is-invalid");
                        var label = event.fields[key].container.nextElementSibling;
                        if (label) {
                            utility.removeClass(label, "show");
                        }

                        if (event.fields[key].isValid === false) {
                            utility.addClass(event.fields[key].container, "is-invalid");
                            if (label) {
                                utility.addClass(label, "show");
                            }
                            allValid = false;
                            break;
                        }

                    }

                    if (allValid) {
                        submit.removeAttribute('disabled');
                        that.checkBraintreeHostedFormValid = true;
                    } else {
                        submit.setAttribute("disabled", "disabled");
                        that.checkBraintreeHostedFormValid = false;
                    }
                });

                // check for unsupported card types - UI update to inform user TODO
                //hostedFieldsInstance.on('cardTypeChange', function (event) {
                //     if (event.cards.length === 1) {
                //        var card = event.cards[0]; 
                //    } else {
                //        // reset to defaults
                //    }
                //});
     
                form.addEventListener('submit', function (event) {
                    event.preventDefault(); 
                    var state = hostedFieldsInstance.getState();
                    var formValid = Object.keys(state.fields).every(function (key) {
                        return state.fields[key].isValid;
                    });

                    if (formValid) {// Tokenize Hosted Fields
                        hostedFieldsInstance.tokenize(function (tokenizeErr, payload) {
                            if (tokenizeErr) {
                                let error = `There was an error when submitting your card.<br/>Please try again.`;
                                utility.logError("HF New Card Deposit: createHostedFields Tokenize Error", tokenizeErr, function () {
                                    that.handlePayPalError(error);
                                });
                                return;
                            }

                            const paymentOption = that.activePaymentMethod.dataset.methodname;
                            const paymentAmount = that.paymentAmount.value;
                            that.validateDeposit(paymentOption, paymentAmount, deviceData, payload.nonce);
                        });
                    } else {
                        // Let the customer know their fields are invalid
                        utility.disableButton(submit);
                    }
                }, false);

                // set a variable so that braintree.hostedFields.create is called once only
                that.checkBraintreeHostedFields = true;
            });
        }

        createCVVOnlyHostedFields(deviceData, clientInstance) {
            let cvvPopup = document.getElementById('deposit--hosted-cvv-popup');
            utility.showPopup(cvvPopup);

            let that = this;
            that.enableSubmitButtons();
            let form = document.getElementById('paypal-hosted-cvv');
            let submit = document.getElementById('submit-hosted-cvv');
            let cancel = document.getElementById('cancel-hosted-cvv');
            let cvvonly = true;
            submit.setAttribute("disabled", "disabled");

            if (!that.checkCvvOnlyHostedFields) { 
                braintree.hostedFields.create({
                    preventAutofill: false,
                    client: clientInstance,
                    styles: {
                        input: {
                            'input': 'hosted-fields',
                            'font-size': '1rem',
                             color: '#2C68A5'
                        },
                        'input.invalid': {
                            'color': 'red'
                        }, 
                    },
                    fields: {
                        cvv: {
                            maxlength: 3,
                            container: '.hosted-cvv-only',
                            placeholder: 'Enter valid 3-digit CVV'
                        }
                    }
                }, function (hostedFieldsErr, hostedFieldsInstance) {
                    if (hostedFieldsErr) {
                        let error = `There was an error when trying to add a new card.<br/>Please try again.`;
                        utility.logError("HF Deposit Update CVV Only: Error creating client", hostedFieldsErr, function () {
                            that.handlePayPalError(error);
                        });
                        return;
                    }

                    // Set auto focus on card number
                    hostedFieldsInstance.focus('cvv', function (focusErr) {
                        if (focusErr) {
                            console.error(focusErr);
                        }
                    });

                    hostedFieldsInstance.on('blur', function (event) {
                        var field = event.fields[event.emittedBy];
                        var container = field.container;
                        var label = container.nextElementSibling;

                        if (field.isEmpty) {
                            utility.addClass(label, "show");
                            utility.addClass(container, "is-invalid");
                        }
                        //else {
                        //    utility.removeClass(label, "show");
                        //    utility.removeClass(container, "is-invalid");

                        //}
                    });

                    // check validity and enable submit
                    hostedFieldsInstance.on('validityChange', function (event) {
                        var allValid = true;
                        var key;

                        for (key in event.fields) {
                            utility.removeClass(event.fields[key].container, "is-invalid");
                            var label = event.fields[key].container.nextElementSibling;
                            if (label) {
                                utility.removeClass(label, "show");
                            }

                            if (event.fields[key].isValid === false) {
                                utility.addClass(event.fields[key].container, "is-invalid");
                                if (label) {
                                    utility.addClass(label, "show");
                                }
                                allValid = false;
                                break;
                            }
                        }


                        if (allValid) {
                            submit.removeAttribute('disabled');
                        } else {
                            submit.setAttribute("disabled", "disabled");
                        }
                    });

                    form.addEventListener('submit', function (event) {
                        event.preventDefault();
                        var state = hostedFieldsInstance.getState();
                        var formValid = Object.keys(state.fields).every(function (key) {
                            return state.fields[key].isValid;
                        });

                        if (formValid) {// Tokenize Hosted Fields
                            if (submit) {
                                utility.disableButton(submit);
                            }

                            hostedFieldsInstance.tokenize(function (tokenizeErr, payload) {
                                if (tokenizeErr) {
                                    let error = `There was an error when submitting your card.<br/>Please try again.`;
                                    utility.logError("HF Submit CVV Only: tokenizeErr", tokenizeErr, function () {
                                        that.handlePayPalError(error);
                                    });
                                    return;
                                }
                            //clear the cvv field
                                hostedFieldsInstance.clear('cvv');
                                hostedFieldsInstance.focus('cvv');
                                utility.hidePopups();

                               that.performPayPalDeposit(deviceData, payload.nonce, cvvonly)

                            });
                        } else {
                            // Let the customer know their fields are invalid
                            utility.disableButton(submit);
                        }
                    }, false);

                    //Cancel CVV Popup
                    cancel.addEventListener('click', function () {
                        hostedFieldsInstance.clear('cvv');
                        hostedFieldsInstance.focus('cvv');
                        utility.hidePopups();
                     });

                    that.checkCvvOnlyHostedFields = true;

                });
            }
        }

        /** PayPal Buttons */
 
        handlePayPalError(error) {
            if (!error) {
                error = `<p>Something went wrong.</p><p>Please contact Customer Support.</p>`
            }
            utility.showNotificationPopup(
                {
                    title: "Error", content: error, hideCloseIcon: true,
                    centreContent: true,
                    button: {
                        text: "OK",
                        url: "/account/deposit/"
                    }
                }
            );

        }

        performPayPalDeposit(deviceData, nonce, isCvvNonce) {
            let formData = utility.getFormData(this.depositForm);
            if (deviceData) {
                formData += `&BTRDeviceData=${deviceData}`
            }
            if (nonce) {
                if (isCvvNonce) {
                    formData += `&BTRCvvNonce=${encodeURIComponent(nonce)}`
                } else {
                    formData += `&BTRPaymentNonce=${encodeURIComponent(nonce)}`
                }
            } 

            const ajaxSuccess = (e) => {
                utility.removeFormInputErrors(this.depositForm);
                this.handleDepositCompleteResponse(JSON.parse(e.target.responseText));
            };
            const ajaxError = (e) => {
                utility.showNotificationPopup({
                     title: "Error", content: `<p class='text-center'>${e.target.responseText}</p>`, hideCloseIcon: true,
                    button: {
                        text: "OK",
                        url: "/account/deposit/"
                    }
                });
                this.enableSubmitButtons();
                this.enablePaymentMethods();
                utility.removeClass(this.activePaymentMethod, "disabled")
                utility.removeFormInputErrors(this.depositForm);
            };

            const ajaxAlways = () => {
                this.enableSubmitButtons();
                this.enablePaymentMethods();
                utility.removeClass(this.activePaymentMethod, "disabled")
            };
            const ajaxOptions = {
                url: "/api/web/account/perform-deposit",
                method: "POST",
                data: formData,
                success: ajaxSuccess,
              //  always: ajaxAlways,
                error: ajaxError
            };

            this.disableSubmitButtons();
            //disable paypal active payment method while this happens
            utility.addClass(this.activePaymentMethod, "disabled");            
            utility.ajaxRequest(ajaxOptions);
        }

        handlePayPal(action) {
            let savePayPal = this.savePayPal;
            let getClientTokenApi;
            let amount = this.paymentAmount.value;
            let payPalLoading = document.getElementById("paypal-button");

            //change api call for hostedfield 
            if (action && (action == 'hosted' || action == 'edithosted')) {
                getClientTokenApi = `/api/web/account/payment-methods/braintree/get-client-token?paymentmethodid=1001&save=${savePayPal}`
            }
            else if (action && (action == 'hosted-deposit')) {
                getClientTokenApi = `/api/web/account/payment-methods/braintree/cc/saved/get-client-data?customerPaymentMethodId=${this.customerPaymentMethodId}&amount=${amount}`;
                utility.showNotificationPopup({
                    title: "Processing Credit Card",
                    centreContent: true,
                    hideCloseIcon: true,
                    content: `Please wait...`
                });
            }
            else {
                getClientTokenApi = `/api/web/account/payment-methods/braintree/get-transaction-client?paymentmethodid=4001&save=${savePayPal}`
                if (payPalLoading) {
                    payPalLoading.innerHTML = `<p class='text-center'>Loading PayPal...</p>`;
                }
            }

            // Loading state while creating paypal buttons
            if (action == 'paypal') {       
                this.depositForm.querySelector("input[name=PaymentMethodId]").value = 4001;
                this.depositForm.querySelector("input[name=SavePayPal]").value = savePayPal;
                if (payPalLoading) {
                    payPalLoading.innerHTML = `<p class='text-center'>Loading PayPal...</p>`;
                }
                if (amount <= 0) {
                    payPalLoading.innerHTML = `<h3>Deposit amount needs to be greater than zero.</h3>`;
                    return;
                }      
            }

            let that = this;
            fetch(getClientTokenApi, { method: 'GET' })
                .then(response => response.json())
                .then(response => {
                    if (response.Success) {
                        braintree.client.create({
                            authorization: response.ClientToken
                        }, function (clientErr, clientInstance) {
                            if (clientErr) {
                                let error = `There was an error when trying to add a new card.<br/>Please try again.`;
                                utility.logError(`Deposit Page getClientTokenApi Action - ${action }: Error creating client`, clientErr, function () {
                                    that.handlePayPalError(error);
                                });
                                return;
                            }

                            // Data Collector
                            braintree.dataCollector.create({
                                client: clientInstance,
                                clientMetadataId: response.ClientMetaDataId
                            }, function (err, dataCollectorInstance) {     
                                let deviceData = "";
                                if (err) {                                    
                                    utility.logError(`Deposit Page getClientTokenApi Action - ${action}: DataCollector Error`, err, null);
                                    // Handle data collector error for paypal only.  Credit card can continue.
                                    if (!action || action != 'hosted-deposit' && action != 'hosted') {
                                        let error = `There was an error. Please turn off any adblockers or VPNs and try again.`;
                                        that.handlePayPalError(error);
                                        return;
                                    }                                                                        
                                }
                                else {
                                    deviceData = dataCollectorInstance.deviceData;
                                }
                                
                                beginPayPalCheckout(deviceData, response.ClientMetaDataId)
                            
                            });                            
                            function beginPayPalCheckout(deviceData, clientMetaDataId) {
                                // Create PayPal Buttons
                                if (action == 'paypal') {
                                    const btnStyle = {
                                        layout: 'vertical',
                                        color: savePayPal ? 'blue' :'gold',
                                        shape: 'pill',
                                        label: savePayPal ? 'paypal' : 'checkout', //paypal, checkout, buynow, pay
                                        disableMaxWidth: true,
                                        height: 40
                                    };
                                    const paypalSdkConfig = {
                                        vault: savePayPal ? true : false,
                                        currency: 'AUD',
                                        intent: 'capture'
                                    };
                                    const paypalPaymentConfig = {
                                        flow: 'checkout', // Required
                                        intent: 'capture',
                                        amount: amount,
                                        currency: 'AUD',
                                        requestBillingAgreement: savePayPal ? true : false,
                                        riskCorrelationId: clientMetaDataId
                                    };

                                    // Create a PayPal Checkout Component.
                                    braintree.paypalCheckout.create({
                                        client: clientInstance
                                    }, function (paypalCheckoutErr, paypalCheckoutInstance) {
                                        if (paypalCheckoutErr) {
                                            let error = `There was an error creating PayPal Checkout.`;
                                            utility.logError("Deposit Page paypalCheckout.create paypalCheckoutErr", paypalCheckoutErr, function () {
                                                that.handlePayPalError(error);
                                            });

                                             if (payPalLoading) {
                                                payPalLoading.innerHTML = 'Error creating PayPal Checkout';
                                            }
                                            return;
                                        }
                                        // Load the PayPal JS SDK (see Load the PayPal JS SDK section)
                                        paypalCheckoutInstance.loadPayPalSDK(
                                            paypalSdkConfig
                                            , function () {
                                                const paypal = window.paypal;
                                                if (payPalLoading) {
                                                    payPalLoading.innerHTML = '';
                                                }

                                                paypal &&
                                                    paypal.Buttons({
                                                        fundingSource: paypal.FUNDING.PAYPAL,
                                                        style: btnStyle,                                                        
                                                        createOrder: function () {
                                                            return paypalCheckoutInstance.createPayment(
                                                                paypalPaymentConfig
                                                            );
                                                        },
                                                        onApprove: function (data, actions) {
                                                            //disable payment method so it cant be re clicked on slower connections
                                                            utility.addClass(that.activePaymentMethod, "disabled");
                                                            that.disablePaymentMethods();
                                                            return paypalCheckoutInstance.tokenizePayment(data, function (err, payload) {
                                                                that.performPayPalDeposit(deviceData, payload.nonce)
                                                            });
                                                        },
                                                        onCancel: function (data) {
                                                            utility.removeClass(that.activePaymentMethod, "disabled");
                                                            that.enablePaymentMethods();
                                                        },
                                                        onError: function (err) {
                                                            utility.removeClass(that.activePaymentMethod, "disabled");
                                                            that.enablePaymentMethods();

                                                            let error = `Paypal Error. Please contact customer support`;
                                                            utility.logError("paypalCheckoutInstance.loadPayPalSDK Error", err, function () {
                                                                that.handlePayPalError(error);
                                                            });
                                                        }
                                                    }).render('#paypal-button').then(function () {
                                                        const payPalSaveCheck = that.depositForm.querySelector("input[name=SavePayPal]");

                                                        if (payPalSaveCheck) {
                                                            payPalSaveCheck.removeAttribute("disabled");
                                                            utility.removeClass(document.getElementById("checkSavePayPal"), "disabled");
                                                        }
                                                    });

                                            });
                                    });
                                }

                                // Tokenized Paypal Depostis
                                if (action == 'paypal-deposit') {
                                    that.performPayPalDeposit(deviceData)
                                }
                                // Tokenized Hosted Deposits
                                if (action == 'hosted-deposit') { 
                                    let authRequired = response.AuthRequired;
                                    let threeDSAvailable = response.ThreeDSAvailable;
                                    let threeDSAuthData = response.ThreeDSAuthData;

                                    // If AuthRequired is false, not mastercard - continue normal deposit
                                    if (!authRequired) {
                                        that.performPayPalDeposit(deviceData)
                                    }
                                    // check if auth required is true and threeDSAvailable is true.
                                    else if (threeDSAvailable && deviceData) {
                                        braintree.threeDSecure.create({
                                           // client: clientInstance,
                                            authorization: response.ClientToken,
                                            version: '2'
                                        }, function (threeDSecureErr, threeDSecure) {
                                            if (threeDSecureErr) {
                                                utility.logError("Deposit Page threeDSecure.create threeDSecureErr", threeDSecureErr, null);
                                                that.createCVVOnlyHostedFields(deviceData, clientInstance);
                                                return;
                                            }
                                            threeDSecure.on('lookup-complete', function (data, next) {
                                                utility.hidePopups();

                                                //// check if challenge is presented, skip and ask for cvv instead
                                                ////else continue
                                                //console.log(data)
                                                //if (data.paymentMethod.threeDSecureInfo.status) {
                                                //    console.info("threeDSecureInfo Status: ",data.paymentMethod.threeDSecureInfo.status);
                                                //}
                                                //if (data.paymentMethod.threeDSecureInfo.status && data.paymentMethod.threeDSecureInfo.status == "challenge_required") {
                                                //    console.log("3DS Challenge - call CVV Popup Instead");   

                                                //    that.createCVVOnlyHostedFields(deviceData, clientInstance);   
       
                                                //    fetch(`/api/web/account/payment-methods/braintree/cc/saved/validate-threeds?customerPaymentMethodId=${that.customerPaymentMethodId}&nonce=${data.paymentMethod.nonce}`, { method: 'GET' })
                                                //        .catch(e => console.info("validate threeDSecure error on challenge:", e));
                                                //    return
                                                //}
                                                next();
                                            });
                                            threeDSecure.verifyCard(threeDSAuthData, function (err, response) {
                                                // Handle response
                                                if (err) {
                                                    // Cardinal SDK Error
                                                    //Show CVV challenge
                                                    utility.logError("Deposit Page threeDSecure.verifycard err", err, null);
                                                    that.createCVVOnlyHostedFields(deviceData, clientInstance);                                    
                                                    return
                                                }
                                                let threedsNonce = response.nonce;
                                                let cardinalData = JSON.stringify(response.rawCardinalSDKVerificationData);
                                                let validateThreedsApi = `/api/web/account/payment-methods/braintree/cc/saved/validate-threeds?customerPaymentMethodId=${that.customerPaymentMethodId}&nonce=${threedsNonce}&cardinalData=${cardinalData}`;
                                                fetch(validateThreedsApi, { method: 'GET' })
                                                .then(response => response.json())
                                                    .then(response => {
                                                        // V Valid 3DSecure authentication successful.  Pass the returned nonce with device data to deposit method to continue.
                                                        // I Invalid 3DSecure authentication was rejected.  Do not continue with deposit.
                                                            //C User Cancelled
                                                        if (response.ResultCode == 'V') {
                                                            that.performPayPalDeposit(deviceData, threedsNonce)
                                                        }
                                                        else if (response.ResultCode == 'I')  {
                                                            // Show not successful UI popup
                                                                that.createCVVOnlyHostedFields(deviceData, clientInstance);                                                          
                                                        }                                                          
                                                        else if (response.ResultCode == 'C') {
                                                            // Dont Do anything
                                                        }
                                                        else {
                                                            //catch all
                                                            that.handlePayPalError()
                                                        }

                                                }).catch((error) => {                                                    
                                                    utility.showNotificationPopup({
                                                        title: "Error Processing Card", content: `<p class='text-center'>Something went wrong, please try again.</p>`, hideCloseIcon: true,
                                                        centreContent: true,
                                                        button: {
                                                            text: "OK",
                                                            url: "/account/deposit/"
                                                        }
                                                    });
                                                });
                                            });
                                        });
                                    }
                                    // if auth req = true -> ask for cvv
                                    else {
                                        that.createCVVOnlyHostedFields(deviceData, clientInstance);
                                    }
                                }

                                // New Credit Card (using clientInstance only to save on api call - backend)
                                if (action == 'hosted') {
                                    that.createHostedFields(deviceData, clientInstance);
                                }
                            }
                        });             
                    } else {
                        // response not success or unauthorized

                        utility.logError("Deposit: Fetch getClientTokenApi failed",response.Message, function () {
                            utility.showNotificationPopup({
                                title: "Error", content: `<p class='text-center'>${response.Message}</p>`, hideCloseIcon: true,
                                centreContent: true,
                                button: {
                                    text: "OK",
                                    url: "/account/deposit/"
                                }
                            });
                        });

                    }                                     
                }).catch((error) => {
                    //Unauthorized 
                    utility.showLoginPopup();
                });
        }
    },

    resultExpandClick: function () {
        [...document.querySelectorAll("#account--add-funds .payment-expand")].map(el => {
            const details = el.nextElementSibling;
            if (details && details.classList.contains("payment-content")) {
                el.onclick = () => {
                    [...document.querySelectorAll("#account--add-funds .payment-expand")].map(el => {
                        utility.removeClass(el, "active");
                        if (el.nextElementSibling) {
                            el.nextElementSibling.style.maxHeight = 0;
                        }
                    });
                    utility.toggleClass(el, "active");
                    if (el.classList.contains('active')) {
                        details.style.maxHeight = `${details.scrollHeight}px`;
                    }
                    else {
                        details.style.maxHeight = 0;
                    }
                };
            }
        });
    }
}

export default depositFunds


// WEBPACK FOOTER //
// ./assets/src/js/classes/depositFunds.js